import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'input-digit-component', templateUrl: './input-digit.component.html', styleUrls: ['./input-digit.component.scss'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputDigitComponent {
    @Input() control: FormControl = new FormControl();
    @Input() hasKeyUp: boolean = true;
    @Input() hasPaste: boolean = true;
    @Input() inputId: string = null;
    @Input() placeholder: string = '0';

    @Output() onPaste: EventEmitter<ClipboardEvent> | null = new EventEmitter<any>();
    @Output() onKeyUp: EventEmitter<KeyboardEvent> | null = new EventEmitter<any>();

    onKeyUpFunction($event: KeyboardEvent) {
        if (!this.hasKeyUp)
            return;

        this.onKeyUp.emit($event);
    }

    onPasteFunction($event: ClipboardEvent) {
        if (!this.hasPaste)
            return;

        this.onPaste.emit($event);
    }
}
